import { Construction } from 'lucide-react';
import { Card, SectionHeader } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';

type Props = {
  kicker: string;
  title: string;
  description: string;
  planned: string[];
};

export function ModulePlaceholder({ kicker, title, description, planned }: Props) {
  return (
    <div className="space-y-10">
      <SectionHeader
        kicker={kicker}
        title={title}
        description={description}
        action={<Badge tone="warning">In Development</Badge>}
      />

      <Card className="relative overflow-hidden">
        <div className="absolute inset-0 bg-blueprint bg-blueprint opacity-10" />
        <div className="relative flex flex-col items-center text-center py-16 px-6">
          <div className="h-14 w-14 rounded-sm border border-brass-400/40 flex items-center justify-center mb-6">
            <Construction className="text-brass-300" size={22} />
          </div>
          <div className="kicker text-brass-300 mb-3">Module Scaffolded</div>
          <h3 className="font-display text-2xl text-text mb-3">Foundation ready — features on the roadmap.</h3>
          <p className="text-text-muted max-w-lg leading-relaxed mb-10">
            This module's route, role-gate and API surface are wired up.
            The functional implementation is queued for the next build phase.
          </p>

          <div className="w-full max-w-md">
            <div className="kicker mb-3 text-left">Planned Capabilities</div>
            <ul className="space-y-2 text-left">
              {planned.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-text-muted">
                  <span className="mt-2 h-px w-4 bg-border-accent shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Card>
    </div>
  );
}
